import { render } from "./incomingMaterialForm.vue?vue&type=template&id=1ca28164&scoped=true"
import script from "./incomingMaterialForm.vue?vue&type=script&lang=js"
export * from "./incomingMaterialForm.vue?vue&type=script&lang=js"

import "./incomingMaterialForm.vue?vue&type=style&index=0&id=1ca28164&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca28164"]])

export default __exports__